/**
 * Checkout Flow Configuration
 * 
 * USE_COD_ONLY_FLOW: 
 *   - true: Specific "Staff will contact you" confirmation popup + Auto-cash order.
 *   - false: Standard "Select Payment Method" modal (COD & Online).
 */
export const CHECKOUT_FLOW_CONFIG = {
  USE_COD_ONLY_FLOW: false,
};
